import { Link, useLocation } from 'react-router-dom';
import { useLocale } from '../../app/locale/LocaleProvider';
import { findPersonalityType } from '../../data/taxonomy';

type StoredComparison = {
  friendTypeId?: string;
  playerTypeId?: string;
  sceneCodes?: string[];
};

function displayType(typeId: string | undefined, locale: 'zh-CN' | 'en') {
  if (!typeId) return locale === 'zh-CN' ? '未知' : 'Unknown';
  const type = findPersonalityType(typeId);
  if (!type) return typeId.replaceAll('_', ' ');
  return locale === 'zh-CN' ? type.zhShare : type.enShare;
}

function readStoredComparison(): StoredComparison {
  const raw = sessionStorage.getItem('vibeArcade.challengeComparison');
  if (!raw) return {};
  try {
    return JSON.parse(raw) as StoredComparison;
  } catch {
    return {};
  }
}

export function ComparePage() {
  const { locale } = useLocale();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const stored = readStoredComparison();
  const friendTypeId = params.get('friend') ?? stored.friendTypeId;
  const playerTypeId = params.get('you') ?? stored.playerTypeId;
  const sceneCodes = (params.get('c') ?? '').split('.').filter(Boolean);
  const sameSceneCount = sceneCodes.length || stored.sceneCodes?.length || 0;

  return (
    <main className="compare-page">
      <h1>{locale === 'zh-CN' ? '你们的社交事故对照' : 'Your social incident comparison'}</h1>
      <p>{locale === 'zh-CN' ? '你和朋友的结果已在本地生成。' : 'Your local comparison is ready.'}</p>
      <section aria-label={locale === 'zh-CN' ? '本地对照' : 'Local comparison'}>
        <article>
          <p>{locale === 'zh-CN' ? '朋友' : 'Friend'}</p>
          <h2>{displayType(friendTypeId, locale)}</h2>
        </article>
        <article>
          <p>{locale === 'zh-CN' ? '你' : 'You'}</p>
          <h2>{displayType(playerTypeId, locale)}</h2>
        </article>
      </section>
      <p>
        {locale === 'zh-CN'
          ? `${sameSceneCount} 个同款场景提示`
          : `${sameSceneCount} same-scene prompts`}
      </p>
      <Link to="/play">{locale === 'zh-CN' ? '再测一次' : 'Play again'}</Link>
    </main>
  );
}
